import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

var config = {
  apiKey: "AIzaSyB_vOS-ZyGh74H7cujmFX3BYhNjGoOuEhk",
  authDomain: "keiki-262db.firebaseapp.com",
  databaseURL: "https://keiki-262db.firebaseio.com",
  projectId: "keiki-262db",
  storageBucket: "keiki-262db.appspot.com",
  messagingSenderId: "982879259314"
};
  
  if (!firebase.apps.length) {
    firebase.initializeApp(config);
  }

  const db = firebase.firestore();
  const auth = firebase.auth();
  const storage = firebase.storage();

export {
  db,
  auth,
  storage
};


// WEBPACK FOOTER //
// ./src/assets/firebase/firebase.js